module.exports = __webpack_public_path__ + "img/hall2.9c971d45.png";